import { Component, EventEmitter, Output, Input } from '@angular/core';

@Component({
	selector: 'ng-form-submit-buttons',
	templateUrl: './form-submit-buttons.html'
})
export class NmFormSubmitButtons {
	@Input() isView: boolean = false;
	@Output('onSubmit') onSubmit = new EventEmitter();
	@Output('onCancel') onCancel = new EventEmitter();
}


// WEBPACK FOOTER //
// ./src/widgets/form-submit-buttons/form-submit-buttons.ts